/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useScrollToTopIfHashNotSet() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      // setTimeout is used so its done on the next render cycle, and not immediately
      setTimeout(() => window.scrollTo(0, 0));
    }
  }, []);
}
